// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"633":"9c752df7","970":"0ee5ba46"}[chunkId] + ".chunk.js";
};